import DapDSSnackbar from './snackbar.component'

export * from './snackbar.component'
export default DapDSSnackbar

DapDSSnackbar.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-snackbar': DapDSSnackbar
  }
}
